import { BASE_URL, pythonBaseUrl } from "../App_Settings/app_settings";

export type InvoiceSummary = {
  id: string;
  invoiceNumber: string;
  clientName: string;
  amount: number;
  currency: string;
  status: "Paid" | "Unpaid" | "Overdue" | "Draft";
  issuedDate: string; // ISO
  dueDate: string; // ISO
};

export type InvoiceDetail = InvoiceSummary & {
  items: Array<{
    description: string;
    quantity: number;
    unitPrice: number;
    total: number;
  }>;
  notes?: string;
  billingEmail?: string;
  organizationId?: string;
};

export async function fetchInvoices(organizationId: string): Promise<InvoiceSummary[]> {
  const response = await fetch(`${BASE_URL}/Billing/Invoices/${organizationId}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token") ? JSON.parse(localStorage.getItem("token") as string).token : ""}`,
      "Content-Type": "application/json",
    },
  });
  if (!response.ok) throw new Error(`Failed to fetch invoices (${response.status})`);
  return response.json();
}

export async function fetchInvoiceById(invoiceId: string): Promise<InvoiceDetail> {
  const response = await fetch(`${BASE_URL}/Billing/Invoice/${invoiceId}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token") ? JSON.parse(localStorage.getItem("token") as string).token : ""}`,
      "Content-Type": "application/json",
    },
  });
  if (!response.ok) throw new Error(`Failed to fetch invoice (${response.status})`);
  return response.json();
}

export async function downloadInvoicePdf(invoiceId: string): Promise<Blob> {
  const response = await fetch(`${pythonBaseUrl}/Billing/Invoice/${invoiceId}/pdf`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token") ? JSON.parse(localStorage.getItem("token") as string).token : ""}`,
    },
  });
  if (!response.ok) throw new Error(`Failed to download invoice PDF (${response.status})`);
  return response.blob();
}

export async function emailInvoice(invoiceId: string, recipientEmail: string): Promise<void> {
  const response = await fetch(`${pythonBaseUrl}/Email/SendInvoice`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token") ? JSON.parse(localStorage.getItem("token") as string).token : ""}`,
    },
    body: JSON.stringify({ invoiceId, recipientEmail }),
  });
  if (!response.ok) throw new Error(`Failed to send invoice email (${response.status})`);
}
